import { Control, FieldValues, useFormState } from "react-hook-form";
import { useBlocker } from "react-router";

import GaiaConfirmCloseDialog from "../GaiaConfirmCloseDialog";

type Props<T extends FieldValues = FieldValues> = {
    control: Control<T>;
};

export default function GaiaHookFormConfirmCloseDialog<T extends FieldValues = FieldValues>({ control }: Props<T>) {
    const { isDirty, isSubmitted, isSubmitting } = useFormState({ control });
    const blocker = useBlocker(isDirty && !isSubmitting && !isSubmitted);

    return <GaiaConfirmCloseDialog blocker={blocker} />;
}
